<div class="col-md-12">
  <div class="row-no-margin">
    <span class="popup-header">RMA: {{rma.RMANumber}}</span>
  </div>
  <div class="row-no-margin">
    <span class="popup-value" style="font-size:12px;max-width:60%;">{{rmaItem.Reason}}</span>
  </div>
  <div class="row-no-margin" style="margin-top:10px;">
    <div class="col-md-2">
      <span class="popup-label">Original Order #</span>
      <br />
      <span class="popup-value">{{rmaItem.OrderNumber}}</span>
    </div>
    <div class="col-md-2">
      <span class="popup-label">Status</span>
      <br />
      <span class="popup-value">{{rmaItem.RMAStatus == 'F' ? "Filled" : rmaItem.RMAStatus}}</span>
    </div>
    <div class="col-md-3">
      <span class="popup-label">Estimated Ship Date</span>
      <br />
      <span class="popup-value">{{rmaItem.EstShipDate | date:'M/d/y'}}</span>
    </div>
    <div class="col-md-3" style="text-align:right;">
      <ng-container *ngIf="!rmaItem.Response && rmaItem.EvalDate && !rmaItem.DispDate">
        <button type="button" class="blue" (click)="RMARespond_Click()" value="RESPOND">RESPOND</button>
      </ng-container>
    </div>
  </div>
  <div class="row-no-margin bottom-border" style="margin-top:10px;">
    <span class="popup-sub-header">Evaluation Information</span>
  </div>

  <div class="row-no-margin" style="margin-top:10px;">
    <div class="col-md-2">
      <span class="popup-label">
        Disposition Date
      </span>
      <br />
      <span class="popup-value">{{rmaItem.DispDate}}</span>
    </div>
    <div class="col-md-2">
      <span class="popup-label">Evaluation Code</span>
      <br />
      <span class="popup-value">{{rmaItem.EvalDesc}}</span>
    </div>
    <div class="col-md-2">
      <span class="popup-label">Evaluation Date</span>
      <br />
      <span class="popup-value">{{rmaItem.EvalDate}}</span>
    </div>
    <div class="col-md-2">
      <span class="popup-label">Receipt Date</span>
      <br />
      <span class="popup-value">{{rmaItem.LastReturnDate | date:'M/d/y'}}</span>
    </div>

  </div>
  <div class="row-no-margin" style="margin-top:10px;">
    <div class="col-md-2">
      <span class="popup-label">Repair Order</span>
      <br />
      <span class="popup-value clickable blue-color" (click)="GoToOrder(rmaItem.RepairOrder)">{{rmaItem.RepairOrder}}</span>
    </div>
    <div class="col-md-2">
      <span class="popup-label">Disposition Desc</span>
      <br />
      <span class="popup-value">{{rmaItem.DispDesc}}</span>
    </div>
    <div class="col-md-2">
      <span class="popup-label">Ship Date</span>
      <br />
      <!--<span class="popup-value">{{rmaItem.ShipDate}}</span>-->
      <ng-container *ngIf="rmaItem.Shipments.length > 0">
        <ng-container *ngFor="let ship of rmaItem.Shipments">
          <span class="popup-value">{{ship.ShipDate | date:'M/d/y'}}&nbsp;:&nbsp;{{ship.QtyShipped}} Shipped</span>
          <br />
        </ng-container>
      </ng-container>
    </div>
    <div class="col-md-2">
      <span class="popup-label">RMA Verification</span>
      <br />
      <span class="popup-value">{{rmaItem.EvalDate | date:'M/d/y'}}</span>
    </div>
  </div>

  <div>
    <div class="border-bottom">
      <span class="popup-sub-header">Documents</span>
    </div>
    <div class="row-no-margin">
      <ul>
        <li *ngIf="rma.RMAVerificationPath.length > 0" style="list-style:none;padding:5px;"><span class="clickable blue-color" (click)="DownloadVerification()"><fa-icon [icon]="faFileLines" class="clickable blue-color"></fa-icon>&nbsp;RMA Verification</span></li>
        <li *ngIf="rmaItem.RMAEvalPath.length > 0" style="list-style:none;padding:5px;"><span class="clickable blue-color" (click)="DownloadEval()"><fa-icon [icon]="faFileLines" class="clickable blue-color"></fa-icon>&nbsp;RMA Evaluation</span></li>
      </ul>
      
    </div>
  </div>
</div>
<!--<app-modal [hidden]="true"></app-modal>-->
